import styled from 'styled-components/macro';

import { description, mapEtaLabel, navLabel } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Content = styled.div`
  border-radius: 6px;
  margin: 0 0 8px;
  padding: 8px 8px 10px 18px;
  position: relative;
  width: 100%;

  ${({ theme }) => `
    border: 1px solid ${theme.bottomForegroundSecondary};
    transition: border-color ${theme.transitionDurationPrimary};
  `}

  &:before {
    border-radius: 100%;
    content: '';
    height: 24px;
    position: absolute;
    right: 5px;
    top: 5px;
    width: 24px;

    ${({ theme }) => `
      border: 1px solid ${theme.bottomForegroundSecondary};
      background-color: ${theme.bottomBackgroundColor};
      transition: border-color ${theme.transitionDurationPrimary},
        background-color ${theme.transitionDurationPrimary};
    `}
  }
`;

export const Label = styled.label`
  cursor: pointer;
  margin: 10px 0 15px;
  overflow: hidden;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover > ${Content} {
    border-color: ${({ theme }) => theme.bottomForegroundActionPrimary};

    &:before {
      border-color: ${({ theme }) => theme.bottomForegroundActionPrimary};
    }
  }
`;

export const Input = styled.input`
  left: -9999px;
  position: absolute;

  ${({ theme }: IWithThemeProps) => `
    &:focus + ${Content} {
      &:before {
        border-color: ${theme.bottomForegroundActionPrimary};
      }
    }

    &:checked + ${Content} {
      border-color: ${theme.bottomForegroundActionPrimary};

      &:before {
        border-color: ${theme.bottomForegroundActionPrimary};
        background-color: ${theme.bottomForegroundActionPrimary};
        box-shadow: 0 0 0 5px #fff inset;
      }
    }
  `}
`;

export const PartnerName = styled.span`
  ${mapEtaLabel};
`;

export const PartnerDistance = styled.span`
  ${navLabel};
  font-weight: 800;

  padding-left: 7px;

  ${({ theme }) => `
    color: ${theme.bottomForegroundSecondary};
  `}
`;

export const PartnerAddress = styled.span`
  ${description};

  color: ${({ theme }) => theme.bottomForegroundPrimary};
  display: block;
`;
